import { RESTClient } from '@api/client';
import { API_URL } from './apiDictionary';
import { prepareUrl } from 'src/utils/routerHelpers';
import {
  QueryTicketMessageRequest,
  UpdateQueryRequest,
} from '@restore/queries/queries.types';

export const getQCQueries = (
  clinicalTrialId: string,
  filters?: { status?: string; patientCode?: string; visitId?: string; sort?: string; page?: number; size?: number }
) => {
  return RESTClient.get(API_URL.qcQueries, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    params: {
      page: filters?.page ? filters.page - 1 : 0,
      size: filters?.size ?? 10,
      ...(filters?.sort && { sort: filters.sort }),
      status: filters?.status,
      patientCode: filters?.patientCode,
      visitId: filters?.visitId,
    },
  });
};

export const getQCQueryById = (queryId: string, clinicalTrialId: string) => {
  return RESTClient.get(prepareUrl(API_URL.qcQueriesById, [queryId]), {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};

export const updateQCQueryById = (
  queryId: string,
  clinicalTrialId: string,
  body: UpdateQueryRequest
) => {
  const requestData = {
    ...body,
    attachments: [],
  };

  const formData = new FormData();
  formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

  body.attachments.forEach((attachment) => {
    formData.append('attachments', attachment);
  });

  return RESTClient.put(prepareUrl(API_URL.qcQueriesById, [queryId]), formData, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};

export const createQuery = (
  clinicalTrialId: string,
  data: QueryTicketMessageRequest
) => {
  const requestData = {
    ...data,
    message: {
      ...data.message,
      attachments: [],
    },
  };

  const formData = new FormData();
  formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

  data.message.attachments.forEach((attachment) => {
    formData.append('attachments', attachment);
  });

  return RESTClient.post(API_URL.qcQueries, formData, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};

export const getQCQueryRecipients = (clinicalTrialId: string) => {
  return RESTClient.get(API_URL.qcQueriesRecipients, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};
